
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'

// module components
import LeadsFilters from '@/modules/PreferencesModule/components/LeadsFilters/index.vue'

// types
import { Lead, GetLeadsParams } from '@/core/types/preferences.types'

// realisations
import { preferences } from '@/core/realisations/preferences.realisation'

// constants
import { LeadsColumns } from '@/core/constants/columns/Preferences.columns'

// classes
import { DataState } from '@/core/classes/DataState.class'
import { useFile } from '@/common/composable/useFile'

import cut from '@/common/helpers/cut'

export default defineComponent({
    components: {
        LeadsFilters,
        FailedFetch,
        TheTable,
        TableScrollWrapper,
        TheButton,
    },
    setup() {
        const data_state = reactive({
            leads: new DataState<Lead>({}),
        })

        const filters_state = reactive({
            email: null as string | null,
            name: null as string | null,
            source: null as string | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            //
            limit: 50,
        })

        const loadLeads = async (page: number) => {
            data_state.leads.pagination.current_page = page

            try {
                data_state.leads.is_loading = true

                const params = {
                    page,
                    ...filters_state,
                }
                const response = await preferences.getLeadsList(params)

                data_state.leads.list = response.data
                data_state.leads.pagination.total_pages = response.meta.last_page
                data_state.leads.pagination.total_items = response.meta.total

                data_state.leads.is_failed = false
                data_state.leads.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.leads.failure.catchError(error)

                if (!data_state.leads.failure.error_state.is_cancel) {
                    data_state.leads.is_failed = true
                }
            } finally {
                if (!data_state.leads.failure.error_state.is_cancel) {
                    data_state.leads.is_loading = false
                }
            }
        }

        const onLimitChange = (limit: number) => {
            filters_state.limit = limit
            loadLeads(data_state.leads.pagination.current_page)
        }

        onBeforeMount(() => {
            loadLeads(1)
        })

        const applyFilters = (params: GetLeadsParams) => {
            filters_state.email = params.email as string | null
            filters_state.name = params.name as string | null
            filters_state.source = params.source as string | null
            filters_state.createdAtFrom = params.createdAtFrom as string | null
            filters_state.createdAtTo = params.createdAtTo as string | null

            loadLeads(1)
        }

        const resetFilters = () => {
            filters_state.email = null
            filters_state.name = null
            filters_state.source = null
            filters_state.createdAtFrom = null
            filters_state.createdAtTo = null

            loadLeads(1)
        }

        const { saveFile } = useFile()
        const excel_state = reactive({
            is_loading: false,
        })

        const exportExcel = async () => {
            try {
                excel_state.is_loading = true

                const params = {
                    ...filters_state,
                }

                const response = await preferences.exportLeadsExcel(params)
                saveFile(response, 'Лиды')
            } catch (e) {
                console.log(e)
            } finally {
                excel_state.is_loading = false
            }
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            const dateSecond = dateStr.split(' ')[1]
            return dateFirst.split('-').reverse().join('.') + ' ' + dateSecond
        }

        return {
            data_state,
            filters_state,
            excel_state,
            loadLeads,
            applyFilters,
            resetFilters,
            onLimitChange,
            exportExcel,
            LeadsColumns,
            cut,
            formatDate,
        }
    },
})
